import { render, staticRenderFns } from "./profile-change-password-form-by-email.vue?vue&type=template&id=5e3a044a&"
import script from "./profile-change-password-form-by-email.vue?vue&type=script&lang=js&"
export * from "./profile-change-password-form-by-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports